import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import HomePage from "./pages/HomePage";
import ServicesHub from "./pages/ServicesHub";
import ServiceDetail from "./pages/ServiceDetail";
import ContactPage from "./pages/ContactPage";
import CommercialPage from "./pages/CommercialPage";
import SchedulePage from "./pages/SchedulePage";

// Location Pages
import McKinneyPage from "./pages/locations/McKinneyPage";
import PlanoPage from "./pages/locations/PlanoPage";
import AllenPage from "./pages/locations/AllenPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

// Shared
import { BoatmanAI } from "./components/shared/BoatmanAI";
import { ScrollToTop } from "./components/shared/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesHub />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contact/:serviceId" element={<ContactPage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/locations/mckinney" element={<McKinneyPage />} />
          <Route path="/locations/plano" element={<PlanoPage />} />
          <Route path="/locations/allen" element={<AllenPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
        <BoatmanAI />
      </BrowserRouter>
    </div>
  );
}

export default App;
